/* FieldOptionsInput.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3hxITi6wH8%7Bborder-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3vBAKH9r67%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Y7lL48HPE%7Bpadding-inline%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2iEGP2MUDv%7Bgrid-template-columns%3A1fr%20auto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._17lj8p2ADO%7B-moz-column-gap%3Avar(--ds-space-100%2C8px)%3Bcolumn-gap%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4kiQYAUofl%7Bmin-height%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0wOv4Q7zJH%7Bcursor%3Apointer%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0NUa3rjgmf%7Bmax-height%3A230px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGIZbP%7Boverflow-y%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4c065U1Y8M%7Bpadding-block%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrujOvk%7Bbackground-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1eOmH6o126%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0wOv4Qsyl5%7Bcursor%3Anot-allowed%7D");
import React, { useCallback, useEffect, useState } from 'react';
import IconButton from '@atlaskit/button/icon/button';
import { cx } from '@atlaskit/css';
import { ErrorMessage } from '@atlaskit/form/error-message';
import { HelperMessage } from '@atlaskit/form/helper-message';
import AddIcon from '@atlaskit/icon/core/add';
import CrossIcon from '@atlaskit/icon/core/cross';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Grid } from '@atlaskit/primitives/compiled/grid';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import TextField from '@atlaskit/textfield/text-field';
import { defineMessage, useIntl } from 'react-intl';
import { useAnalytics } from '@townsquare/analytics';
const optionValueAriaLabelMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.option-value-aria-label',
  defaultMessage: 'Option value',
  description: 'Accessible label for option value input field'
});
const removeOptionTooltipMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.remove-option-tooltip',
  defaultMessage: 'Remove option',
  description: 'Tooltip shown on the button that removes a select option from the custom field options list.'
});
const optionValueRequiredMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.option-name-required',
  defaultMessage: 'A name is required for this option.',
  description: 'Validation error message shown beneath an option input when the user submits the custom field form without entering a name for that option.'
});
const optionValueTooLongMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.option-value-too-long',
  defaultMessage: 'Must be 50 characters or less.',
  description: 'Error message when option value exceeds character limit'
});
const optionAlreadyExistsMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.option-already-exists',
  defaultMessage: 'This option already exists. Give it another name.',
  description: 'Error message when option value is duplicated'
});
const addOptionMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.add-option',
  defaultMessage: 'Add option',
  description: 'Button label for adding a new option to the select field options list in the custom field form.'
});
const maxOptionsReachedMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.max-options-reached',
  defaultMessage: 'You can select up to 50 items. Remove one to choose another.',
  description: 'Error message when maximum number of options is reached'
});
type OptionErrorType = 'REQUIRED' | 'DUPLICATE' | 'TOO_LONG';
const MAX_OPTION_LENGTH = 50;
type Option = {
  id: string;
  value: string;
  isEditing?: boolean;
  error?: OptionErrorType;
  isPrefillValue?: boolean;
};
const MAX_OPTIONS = 50;
const styles = {
  listItemContainer: "_0bjKvDKxmn _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _39xV02N91d",
  listItem: "_2Y7lL48HPE _2iEGP2MUDv _17lj8p2ADO _0hPCNLDIqT _4kiQYAUofl",
  placeholderText: "_0wOv4Q7zJH",
  optionsListContainer: "_39xV02N91d _0NUa3rjgmf _2WAcuGIZbP",
  addOption: "_0bjKvDKxmn _2Y7lL48HPE _4c065U1Y8M _0wOv4Q7zJH _0KLXrujOvk",
  addOptionHover: "_1eOmH6o126",
  addOptionDisabled: "_0wOv4Qsyl5"
};
function OptionItem({
  option,
  onDelete,
  onValueChange,
  onBlur,
  onStartEditing
}: {
  option: Option;
  onDelete: (id: string) => void;
  onValueChange: (id: string, value: string) => void;
  onBlur: (id: string, value: string) => void;
  onStartEditing: (id: string) => void;
}) {
  const intl = useIntl();
  const [isEditing, setIsEditing] = useState(option.isEditing || false);
  useEffect(() => {
    setIsEditing(option.isEditing || false);
  }, [option.isEditing]);
  const renderOptionContent = () => {
    if (isEditing) {
      return <TextField value={option.value} onChange={(e: React.ChangeEvent<HTMLInputElement>) => onValueChange(option.id, e.target.value)} onBlur={() => onBlur(option.id, option.value)} isCompact autoFocus aria-label={intl.formatMessage(optionValueAriaLabelMessage)} />;
    }
    if (option.isPrefillValue) {
      return <Box as="span" role="button" tabIndex={0} onClick={() => {
        onStartEditing(option.id);
        setIsEditing(true);
      }} onKeyDown={(e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onStartEditing(option.id);
          setIsEditing(true);
        }
      }} xcss={styles.placeholderText}>
					<Text color="color.text.subtlest" weight="medium">
						{option.value}
					</Text>
				</Box>;
    }
    return <Text color="color.text.subtle" weight="medium">
				{option.value}
			</Text>;
  };
  return <Box xcss={styles.listItemContainer}>
			<Grid xcss={styles.listItem}>
				{renderOptionContent()}
				<IconButton icon={CrossIcon} label={intl.formatMessage(removeOptionTooltipMessage)} appearance="subtle" isTooltipDisabled={false} onClick={() => onDelete(option.id)} spacing="compact" />
			</Grid>
		</Box>;
}
type FieldOptionsInputProps = {
  value?: {
    id?: string;
    value: string;
  }[];
  onChange?: (options: {
    id?: string;
    value: string;
  }[]) => void;
};
export function FieldOptionsInput({
  value = [],
  onChange
}: FieldOptionsInputProps): React.JSX.Element {
  const intl = useIntl();
  const analytics = useAnalytics();
  const sortOptions = useCallback((optionsToSort: Option[]) => [...optionsToSort].sort((firstOption, secondOption) => firstOption.value.localeCompare(secondOption.value, intl.locale)), [intl.locale]);
  const [options, setOptions] = useState<Option[]>(() => value.length > 0 ? sortOptions(value.map((option, idx) => ({
    id: option.id ?? `option-${idx}`,
    value: option.value,
    _backendId: option.id
  }))) : [{
    id: 'option-0',
    value: 'Option 1',
    isPrefillValue: true
  }]);
  useEffect(() => {
    onChange?.(options.filter(opt => !opt.error).map(opt => ({
      // Preserve backend ARI id if it exists
      id: (opt as Option & {
        _backendId?: string;
      })._backendId,
      value: opt.value
    })));
    // Intentionally exclude onChange from deps — it's not stable and would cause an infinite loop.
    // We only want to call onChange when options change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);
  const handleDelete = useCallback((id: string) => {
    setOptions(options => {
      const updated = options.filter(opt => opt.id !== id);
      void analytics.ui('teamCustomFieldSelectorOption', 'removed', {
        totalOptions: updated.length
      });
      return updated;
    });
  }, [analytics]);
  const handleValueChange = useCallback((id: string, value: string) => {
    setOptions(options => options.map(opt => opt.id === id ? {
      ...opt,
      value,
      error: undefined
    } : opt));
  }, []);
  const validateOption = useCallback((id: string, value: string): OptionErrorType | undefined => {
    const trimmedValue = value.trim();
    if (!trimmedValue) {
      return 'REQUIRED';
    }
    if (trimmedValue.length > MAX_OPTION_LENGTH) {
      return 'TOO_LONG';
    }
    if (options.some(opt => opt.id !== id && opt.value.trim().toLowerCase() === trimmedValue.toLowerCase())) {
      return 'DUPLICATE';
    }
    return undefined;
  }, [options]);
  const handleBlurOption = useCallback((id: string, value: string) => {
    const error = validateOption(id, value);
    setOptions(options => {
      const updated = options.map(opt => opt.id === id ? {
        ...opt,
        error,
        isEditing: !!error,
        isPrefillValue: false
      } : opt);
      return error ? updated : sortOptions(updated);
    });
  }, [validateOption, sortOptions]);
  const handleStartEditing = useCallback((id: string) => {
    setOptions(options => options.map(opt => opt.id === id ? {
      ...opt,
      isPrefillValue: false
    } : opt));
  }, []);
  const handleAddOption = useCallback(() => {
    setOptions(options => [...options, {
      id: `option-${Date.now()}`,
      value: '',
      isEditing: true
    }]);
    void analytics.ui('teamCustomFieldSelectorOption', 'added');
  }, [analytics]);
  const isMaxOptionsReached = options.filter(opt => !opt.isEditing && opt.value.trim() !== '').length >= MAX_OPTIONS;
  return <Stack space="space.100" alignInline="start">
			<Stack xcss={styles.optionsListContainer} space="space.050">
				{options.map(option => <OptionItem key={option.id} option={option} onDelete={handleDelete} onValueChange={handleValueChange} onBlur={handleBlurOption} onStartEditing={handleStartEditing} />)}
			</Stack>
			{options.some(opt => opt.error) && <Stack space="space.050">
					{options.filter(opt => opt.error).map(opt => <ErrorMessage key={opt.id}>
								{intl.formatMessage({
          REQUIRED: optionValueRequiredMessage,
          TOO_LONG: optionValueTooLongMessage,
          DUPLICATE: optionAlreadyExistsMessage
        }[opt.error!])}
							</ErrorMessage>)}
				</Stack>}
			<Pressable onClick={handleAddOption} isDisabled={isMaxOptionsReached} xcss={cx(styles.addOption, isMaxOptionsReached ? styles.addOptionDisabled : styles.addOptionHover)}>
				<Inline space="space.075" alignBlock="center">
					<AddIcon label="" color={isMaxOptionsReached ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon, #292A2E)"} size="small" />
					<Text color={isMaxOptionsReached ? 'color.text.disabled' : 'color.text.subtle'}>
						{intl.formatMessage(addOptionMessage)}
					</Text>
				</Inline>
			</Pressable>
			{isMaxOptionsReached && <HelperMessage>{intl.formatMessage(maxOptionsReachedMessage)}</HelperMessage>}
		</Stack>;
}